"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconSmartEnergySolutions = function IconSmartEnergySolutions(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    d: "M26 8.97a5 5 0 0 1 5 5v24a5 5 0 0 1-5 5H14a5 5 0 0 1-5-5v-24a5 5 0 0 1 5-5zm-15 29a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3v-2H11zm9.41-.3a.85.85 0 1 1-.001 1.7.85.85 0 0 1 .001-1.7M14 10.97a3 3 0 0 0-3 3v21h18v-21a3 3 0 0 0-3-3zm7 12.53 3-.5-5 8 1-5.5-3 .5 5-8zm1-8.53h-3v-1h3zm7.518-8.595a5.25 5.25 0 0 1 4.465 4.337l.034.227-.994.121a4.25 4.25 0 0 0-3.438-3.662l-.203-.033zm.34-2.46a7.73 7.73 0 0 1 6.606 6.533l.033.256-.994.112a6.73 6.73 0 0 0-5.527-5.87l-.253-.041zm.33-2.41a10.19 10.19 0 0 1 8.693 8.657l.036.281-.994.113a9.19 9.19 0 0 0-7.602-8.02l-.27-.041z"
  })));
};

export { IconSmartEnergySolutions, IconSmartEnergySolutions as default };
